export enum EValveVariant {
  MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_LEFT_VALVE = 'MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_LEFT_VALVE',
  MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_RIGHT_VALVE = 'MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_RIGHT_VALVE',
  MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_NONE = 'MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_NONE',
}
